import { CustomAxios } from '@/services';

export const RoleService = {
  create: ({ name }) => CustomAxios.post('role', { name }),
  getRoles: () => CustomAxios.get('role'),
};
